import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { cargasPreviasAction } from '../../store/actions/carga-masiva-action';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DetalleCarga from "./detalle-carga";
import { Auth } from 'recupero-comunes';

const CargasPrevias = () => {

    const { rutOrganizacion } = Auth.currentUser();
    const query = btoa(JSON.stringify({ "idOrganizacion": rutOrganizacion, "tipoCarga":"108008" }));

    // El hook useSelector (redux) permite acceder al state en nuestro store.
    const dataCargaMasiva = useSelector(state => state.carga_masiva);

    // El hook useDispatch (redux) permite invocar una action.
    const dispatch = useDispatch();

    // El hook useState permite almacenar state. Devuelve un valor con el estado y una función
    const [ verDetalle, setVerDetalle ] = React.useState({ show: false, data: {} });

    const handleReload = () => {

        // Ejecutar acción para obtener cargas previsa.
        dispatch(cargasPreviasAction(query));
    }

    useEffect(() => {

        // Ejecutar acción para obtener cargas previsa.
        dispatch(cargasPreviasAction(query));

    }, [dispatch, query]);

    // Definición de propiedades de cada columna de la tabla
    const columns = [
        {
            dataField: 'id', text: 'ID Carga', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
        },
        {
            dataField: 'fechaCargaFormato', text: 'Fecha Carga', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
        },
        {
            dataField: 'nombreArchivo', text: 'Archivo', headerStyle: { textAlign: 'center', verticalAlign: 'top', align: 'center' }
        },
        {
            dataField: 'cargadosAct', text: 'Cargados/Act', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
        },
        {
            dataField: 'regRechazados', text: 'Rechazados', sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
        },
        {
            dataField: 'total', text: 'Total', isDummyField: true, sort: true, headerAlign: 'center', align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>),
            formatter: (cell, row) => ( row.regCargados + row.regRechazados )
        },
        {
            dataField: 'estadoCarga', text: 'Estado', sort: true, headerAlign: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
        },
        {
            dataField: 'usuarioCarga', text: 'Usuario', sort: true, headerAlign: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{ column.text }<br/>{sortElement}</div>)
        },
        {
            dataField: 'opciones', text: 'Opciones', isDummyField: true, headerStyle: { textAlign: 'center', verticalAlign: 'top' },
            style: { textAlign: 'center', verticalAlign: 'middle' },
            formatter: (cell, row) => {
                return accion(row);
            }
        }
    ];
    const accion = (row) => {

        let lupa = <div>
                        <Button type="button" variant="outline-secondary me-md-2" size="sm" onClick={ () => setVerDetalle({ show: true, data: row }) }>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                        </Button>
                    </div>
        let lupaYexcel = <div>
                        <Button type="button" variant="outline-secondary me-md-2" size="sm" onClick={ () => setVerDetalle({ show: true, data: row }) }>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                        </Button>
                        <Button type="button" variant="outline-success" size="sm" href={row.url} download target="_blank">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-file-earmark-excel" viewBox="0 0 16 16">
                            <path d="M5.884 6.68a.5.5 0 1 0-.768.64L7.349 10l-2.233 2.68a.5.5 0 0 0 .768.64L8 10.781l2.116 2.54a.5.5 0 0 0 .768-.641L8.651 10l2.233-2.68a.5.5 0 0 0-.768-.64L8 9.219l-2.116-2.54z"/>
                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                            </svg>
                        </Button>
                    </div>

        if (row.codEstadoCarga != 58002 && !row.excelResultado) {//(58002) Carga Finalizada
            return lupa;
        } else {
            if (row.codEstadoCarga != 58002 && row.excelResultado) {//(58002) Carga Finalizada
                return lupaYexcel;
            } else {
                return <div></div>
            }
        }
    }

    return (
        <div>
            <ToolkitProvider search bootstrap4 keyField="id"
                data={ dataCargaMasiva.cargas_previas ? dataCargaMasiva.cargas_previas : [] }
                columns={ columns } defaultSorted={ [{ dataField: 'id', order: 'asc' }] }>
                {
                props =>
                    <div>
                        <div className="bg-secondary text-light rounded mt-4">
                            <h5 className="text-center p-2">Cargas Previas</h5>
                        </div>
                        <div className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2">
                            <Form.Control placeholder="Buscar en la grilla" className="w-25" onChange={(e) => { props.searchProps.onSearch(e.target.value) }}/>
                            <Button type="button" variant="outline-secondary" size="sm" onClick={() => { handleReload() }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                            </Button>
                        </div>
                        <BootstrapTable { ...props.baseProps } headerWrapperClasses="table-secondary" pagination={ paginationFactory() } />
                    </div>
                }
            </ToolkitProvider>
            <DetalleCarga show={verDetalle.show} data={verDetalle.data} onHide={() => setVerDetalle({ show: false, data: {} })} />
        </div>
    );
}

export default CargasPrevias;
